import { Home } from "../components/";
import { createBrowserRouter } from "react-router-dom";

export default function routes() {
  return createBrowserRouter([
    {
      path: "/",
      element: <Home />,
    },
  ]);
}
